'use client';
import { useEffect } from 'react';
import { useFetchUser } from '@/auth/hooks';
import { useKvlLogger } from '@/hooks/cbAi/useKvlLogger';

// Module-level guard: ensures one log per full document load, even in React Strict Mode.
let hasLoggedLanding = false;

function buildLandingKvl(): Record<string, string> {
  const kvl: Record<string, string> = {
    event: 'page_initialized',
    pathname: window.location.pathname,
  };

  if (document.referrer) {
    kvl.referrer = document.referrer;
  }

  const params = new URLSearchParams(window.location.search);
  for (const key of [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ] as const) {
    const value = params.get(key);
    if (value) kvl[key] = value;
  }
  return kvl;
}

const ApiExplorerLandingKvl: React.FC = () => {
  const { loading } = useFetchUser();
  const { logKvl } = useKvlLogger();

  useEffect(() => {
    if (loading || hasLoggedLanding) return;
    hasLoggedLanding = true;
    logKvl(buildLandingKvl());
  }, [loading, logKvl]);

  return null;
};

export default ApiExplorerLandingKvl;
